// The values are defined by the backend (EntityTypeEnum)
export enum RelatedEntityType {
  order = 'order',
  payment = 'payment',
  marketplaceItem = 'marketplace_item',
  task = 'task',
  streak = 'streak',
  poolEntry = 'pool_entry',
}

export interface PaymentMethod {
  id: string;
  name: string;
  currency: string;
  provider: string;
  tokenCode: string;
}

interface PaymentDetailsCommon {
  id: string;
  userId: string;
  status: string;
  amount: number;
  fee: number;
  feeCompensation: number;
  fiatAmount: number | null;
  rateSnapshot: string;
  trackerId: string;
  created: Date | null;
  completed: Date | null;
  failureCode: string;
  failureDetail: string;
  method: PaymentMethod | null;
}

export interface DepositDetails extends PaymentDetailsCommon {
  amountFiatReceived: number | null;
  redirectUrl: string;
  promoCode: string;
  promoPercent: number | null;
  promoMaxBonus: number | null;
}

export interface PayoutDetails extends PaymentDetailsCommon {
  amountFiatSent: number | null;
  receiver: string;
}

export interface ProviderRequestLog {
  id: string;
  provider: string;
  direction: string;
  entityType: string;
  endpoint: string;
  method: string;
  url: string;
  statusCode: number | null;
  created: Date;
  requestBody: object | null;
  responseBody: object | null;
}

export interface PaymentMethodInfo {
  name: string;
  currency: string;
  provider: string;
  country: string | null;
}

export interface Transaction {
  id: string;
  userId: string;
  value: number;
  bonus: number;
  localValue: number | null;
  localBonus: number | null;
  currency: string;
  method: PaymentMethodInfo | null;
  coins: number;
  created: Date;
  assetType: string;
  txnType: string;
  relatedEntity: RelatedEntityType | '';
  relatedEntityId: string;
  label: string;
  paymentType: string;
  eventId: string;
  meta: string[];
}
